import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 143785 161862"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#000;stroke-width:2345.82}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970277899264">
        <path
          d="M1173 11811c0 5877 4764 10643 10638 10643 5877 0 10639-4762 10639-10643 0-5874-4762-10638-10639-10638-5874 0-10638 4760-10638 10638zM41228 11811c0 5877 4764 10643 10638 10643 5876 0 10645-4762 10645-10643 0-5874-4764-10638-10645-10638-5878 0-10638 4760-10638 10638z"
          className="fill stroke1"
          style={{
            strokeWidth: 2345.82,
          }}
        />
      </g>
      <g id="_1970277899488">
        <path
          d="M1173 46370c0 5874 4764 10643 10638 10643 5877 0 10639-4764 10639-10643 0-5881-4762-10638-10639-10638-5874 0-10638 4762-10638 10638zM41228 46370c0 5874 4764 10643 10638 10643 5876 0 10645-4764 10645-10643 0-5881-4764-10638-10645-10638-5878 0-10638 4762-10638 10638zM81278 46370c0 5874 4764 10643 10641 10643 5874 0 10638-4764 10638-10643 0-5881-4764-10638-10638-10638-5877 0-10641 4762-10641 10638z"
                    className="fill stroke1"
          style={{
            strokeWidth: 2345.82,
          }}

        />
      </g>
      <g id="_1970277893920">
        <path
          d="M1173 80926c0 5879 4764 10643 10638 10643 5877 0 10639-4764 10639-10643 0-5876-4762-10643-10639-10643-5874 5-10638 4769-10638 10643zM41228 80926c0 5879 4764 10643 10638 10643 5876 0 10645-4764 10645-10643 0-5876-4764-10643-10645-10643-5878 0-10638 4769-10638 10643zM81278 80926c0 5879 4764 10643 10641 10643 5874 0 10638-4764 10638-10643 0-5876-4764-10643-10638-10643-5877 5-10641 4769-10641 10643zM121331 80926c0 5879 4762 10643 10638 10643 5879 0 10643-4764 10643-10643 0-5876-4764-10643-10643-10643-5874 5-10638 4769-10638 10643z"
                    className="fill stroke1"
          style={{
            strokeWidth: 2345.82,
          }}

        />
      </g>
      <g id="_1970277893600">
        <path
          d="M1173 115490c0 5873 4764 10643 10638 10643 5877 0 10639-4765 10639-10643 0-5877-4762-10641-10639-10641-5874-5-10638 4760-10638 10641zM41228 115490c0 5873 4764 10643 10638 10643 5876 0 10645-4765 10645-10643 0-5877-4764-10641-10645-10641-5878 0-10638 4760-10638 10641zM81278 115490c0 5873 4764 10643 10641 10643 5874 0 10638-4765 10638-10643 0-5877-4764-10641-10638-10641-5877-5-10641 4760-10641 10641z"
                    className="fill stroke1"
          style={{
            strokeWidth: 2345.82,
          }}

        />
      </g>
      <g id="_1970277895904">
        <path
          d="M1173 150046c0 5874 4764 10643 10638 10643 5877 0 10639-4765 10639-10643 0-5881-4762-10638-10639-10638-5874-5-10638 4757-10638 10638zM41228 150046c0 5874 4764 10643 10638 10643 5876 0 10645-4765 10645-10643 0-5881-4764-10638-10645-10638-5878 0-10638 4757-10638 10638z"
                    className="fill stroke1"
          style={{
            strokeWidth: 2345.82,
          }}

        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
